import React from 'react';
import type { TextAreaProps } from '@atlaskit/textarea';
import type { RenderFn } from '@atlassian/forge-ui';

const AKTextArea = React.lazy(
    () =>
        import(
            /* webpackChunkName: "atlaskit-textarea" */
            '@atlaskit/textarea'
        )
);

export function useTextArea({ forgeDoc, dispatch }: Parameters<RenderFn>[0]): {
    akTextAreaProps: TextAreaProps;
} {
    const {
        props: {
            name,
            isMonospaced,
            placeholder,
            spellCheck,
            onBlur,
            value,
            appearance = 'standard',
            resize = 'smart',
            minimumRows = 2,
        } = {},
    } = forgeDoc;

    const handleBlur = async (textValue: string) => {
        await dispatch({
            type: 'event',
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            handler: onBlur,
            args: [textValue],
            extensionData: {},
        });
    };

    return {
        akTextAreaProps: {
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            name,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            appearance,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            resize,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            minimumRows,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            isMonospaced,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            placeholder,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            spellCheck,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            value,
            // @typescript-eslint upgrade to v5.61.0
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onBlur: (event) => handleBlur(event.target.value),
        },
    };
}

export function PortalTextArea(props: Parameters<RenderFn>[0]) {
    const { akTextAreaProps } = useTextArea(props);
    return <AKTextArea {...akTextAreaProps} />;
}
